// extracted by mini-css-extract-plugin
module.exports = {"palette__item":"FormulaPalette_palette__item__tMSp8","palette__paletteItemOverlap":"FormulaPalette_palette__paletteItemOverlap__Pq41C"};